const DIMENSION_SPECS = [
  ['Product Width (in.)', 'W'],
  ['Product Depth (in.)', 'D'],
  ['Product Height (in.)', 'H']
];

export const getDimensions = (specificationGroup) => {
  const specifications = (specificationGroup || [])
    .filter((group) => group?.specTitle === 'Dimensions')
    .flatMap((group) => group?.specifications || []);
  const values = DIMENSION_SPECS.map(([specName, axis]) => {
    const value = specifications.find((spec) => spec?.specName === specName)?.specValue;
    return value ? `${value.replace(/\s*in\.?$/, '')}"${axis}` : null;
  });
  return values.every(Boolean) ? values.join(' x ') : null;
};
